/* eslint-disable class-methods-use-this */
/* eslint-disable consistent-return */
class VersionService {
  constructor() {
    this.currentVersion = '1.0.0.0'; // Será atualizada dinamicamente
    this.checkInterval = null;
    this.updateListeners = [];
    this.isCheckingForUpdates = false;
    this.isUpdating = false; // Flag para evitar verificações durante atualização
    this.loadCurrentVersion(); // Carregar versão atual na inicialização
  }

  async loadCurrentVersion() {
    try {
      const response = await fetch(`/version.json?t=${Date.now()}`);
      const versionData = await response.json();
      if (versionData.version) {
        this.currentVersion = versionData.version;
      }
    } catch (error) {
      console.log('Usando versão padrão no VersionService');
    }
  }

  async checkForUpdates() {
    if (this.isCheckingForUpdates || this.isUpdating) return;

    // Verificar se há uma sessão válida (Redux persist ou localStorage)
    const hasValidSession =
      localStorage.getItem('persist:PORTAL-CRM') ||
      sessionStorage.getItem('authToken') ||
      document.cookie.includes('authToken');

    if (!hasValidSession) {
      return; // Não verificar atualizações se não há sessão válida
    }

    this.isCheckingForUpdates = true;

    try {
      // Primeiro, atualizar a versão atual
      await this.loadCurrentVersion();

      const response = await fetch(`/version.json?t=${Date.now()}`, {
        cache: 'no-cache',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });

      if (response.ok) {
        const versionData = await response.json();
        const serverVersion = versionData.version;

        // Verificar se deve mostrar o aviso
        const shouldShowNotification =
          versionData.showUpdateNotification === true;
        const notificationShown = localStorage.getItem(
          `update-notification-${serverVersion}`
        );

        if (shouldShowNotification && !notificationShown) {
          console.log(
            `Nova versão disponível: ${serverVersion} (atual: ${this.currentVersion})`
          );
          this.notifyListeners({
            hasUpdate: true,
            currentVersion: this.currentVersion,
            newVersion: serverVersion,
            versionData,
          });
          return true;
        }
      }
    } catch (error) {
      console.warn('Erro ao verificar atualizações:', error);
    } finally {
      this.isCheckingForUpdates = false;
    }

    return false;
  }

  static forceLogoutAndClearCache() {
    // Marcar como atualizando para evitar novas verificações
    // Usar o singleton existente
    if (window.versionServiceInstance) {
      window.versionServiceInstance.isUpdating = true;
      window.versionServiceInstance.stopVersionCheck();
    }

    // Limpar localStorage
    localStorage.clear();

    // Limpar sessionStorage
    sessionStorage.clear();

    // Limpar cookies relacionados à autenticação
    document.cookie.split(';').forEach((cookie) => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });

    // Recarregar a página
    window.location.reload(true);
  }

  startVersionCheck(intervalMinutes = 5) {
    this.stopVersionCheck();

    this.checkInterval = setInterval(
      () => {
        this.checkForUpdates();
      },
      intervalMinutes * 60 * 1000
    );

    // Verificação inicial
    setTimeout(() => this.checkForUpdates(), 1000);
  }

  stopVersionCheck() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }

  addUpdateListener(callback) {
    this.updateListeners.push(callback);
  }

  removeUpdateListener(callback) {
    this.updateListeners = this.updateListeners.filter(
      (listener) => listener !== callback
    );
  }

  notifyListeners(updateInfo) {
    this.updateListeners.forEach((listener) => {
      try {
        listener(updateInfo);
      } catch (error) {
        console.error('Erro ao notificar listener de atualização:', error);
      }
    });
  }

  getCurrentVersionInfo() {
    return {
      version: this.currentVersion,
      timestamp: new Date().toISOString(),
    };
  }

  dismissUpdate(version) {
    // Marcar notificação como vista no localStorage
    if (version) {
      localStorage.setItem(`update-notification-${version}`, 'true');
    }
    this.isUpdating = false;
    this.notifyListeners({ hasUpdate: false });
  }

  showBuildScripts() {
    console.log('Scripts de build disponíveis:');
    console.log(
      'npm run build:force-update - Build com limpeza de cache e logout forçado'
    );
  }
}

// Instância singleton
const versionService = new VersionService();

// Registrar globalmente para acesso no método estático
window.versionServiceInstance = versionService;

export default versionService;
export { VersionService };
